import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/crop_field_inspect_graphs/${agro_exporter_id}/crop_field`
    );
  },
  fetchExporterQualityTemplate(agro_exporter_id, quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/crop_field_inspect_graphs/${agro_exporter_id}/quality_template/${quality_template_id}`
    );
  },
  fetchCropFields(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/crop_field_inspect_graphs/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  }
};
